export enum ECardType {
  VerticalFullImage,
  VerticalHalfImage,
  HorizontalFullImage,
  HorizontalHalfImage,
}

export interface ICard {
  title: string;
  description: string;
  link: string;
  imageUrl: string;
  buttonText?: string;
}

export interface ITypedCard extends ICard {
  type: ECardType;
}

export interface ICombinedTypedCard extends ITypedCard {
  nextCard?: ITypedCard;
}
